import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneDownOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.983 12.194c-1.513 0-2.593.19-3.234.347-.454.113-.794.458-.964.892L6.78 15.989 1.126 17c-3.91-6.967 3.008-9.998 10.858-10s14.81 3.027 10.89 9.996l-5.655-1.01-1.035-2.566c-.172-.427-.509-.766-.957-.877-.64-.16-1.723-.349-3.244-.349m-9.828 2.793 3.318-.593.637-1.62c.342-.872 1.086-1.703 2.207-1.98.777-.192 2.002-.4 3.666-.4 1.672 0 2.901.209 3.677.401 1.108.275 1.847 1.092 2.193 1.952l.663 1.643 3.33.594c.36-.932.405-1.645.311-2.176-.124-.704-.542-1.362-1.375-1.97-1.769-1.29-5.004-2.039-8.797-2.038-3.794 0-7.017.75-8.776 2.04-.828.607-1.243 1.264-1.367 1.97-.093.532-.047 1.245.313 2.177"
                fill="currentColor"
            />
        </g>
    </svg>
));
PhoneDownOutlinedSize24Glyph.displayName = 'PhoneDownOutlinedSize24Glyph';
